import clsx from 'clsx';
import React, { PropsWithChildren } from 'react';
import styles from './InlineHelp.module.css';

interface InlineHelpProps {
  className?: any;
}

const InlineHelp = (props: PropsWithChildren<InlineHelpProps>) => {
  return <p className={clsx(props.className, styles.inlineHelp, 'text-muted mb-0')}>{props.children}</p>;
};

export default InlineHelp;
